import {
    takeEvery, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/VisitHistoryManagement';
import { waitAuthorizedCheck } from './Auth';

function* getExhibitionViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/company/${action.payload.company_id}/download-csv-product/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetExhibitionViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetExhibitionViewerRequestedReceiveFailure(yield error));
    }
}

function* getSeminarViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/company/${action.payload.company_id}/download-csv-seminar/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetCSVSeminarViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCSVSeminarViewerRequestedReceiveFailure(yield error));
    }
}

function* getLivestreamViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/company/${action.payload.company_id}/download_csv_live_stream/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetCSVLivestreamViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCSVLivestreamViewerRequestedReceiveFailure(yield error));
    }
}

function* getGrandBoothViewer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${action.payload.event_name}/company/${action.payload.company_id}/download_csv_grand_booth/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetCSVGrandBoothViewerRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCSVGrandBoothViewerRequestedReceiveFailure(yield error));
    }
}

export default function* visitHistory() {
    yield all([
        takeEvery('GET_EXHIBITION_VIEWER_REQUESTED', getExhibitionViewer),
        takeEvery('GET_SEMINAR_VIEWER_REQUESTED', getSeminarViewer),
        takeEvery('GET_LIVESTREAM_VIEWER_REQUESTED', getLivestreamViewer),
        takeEvery('GET_GRAND_BOOTH_VIEWER_REQUESTED', getGrandBoothViewer),
    ]);
}
